export default __webpack_public_path__ + "81c0fbb391bcb99c7dbfc6a7ba5fbad4.svg";